import { useNavigate } from 'react-router';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();

  const handleButtonClick = async () => {
    navigate('/verification/');
  };
  return (
    <div className='Home'>
      <div className='Home__container'>
        <div className='Home__card'>
          <p>Evaluate the declared harvest location of a supply chain sample.</p>
          <button className='home-page-btn' type='button' onClick={handleButtonClick}>
            ENTER HERE
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
